import React, { useEffect, useContext, useState } from 'react';
import $ from 'jquery';
import DataTable from 'datatables.net';
import { LoginContext } from '../../hooks/context/LoginContext';
import axios from 'axios';
import Menusup from '../../componentes/menus/menusup/Menusup';
import Sidebar from '../../componentes/menus/sidebar/Sidebar';
import Footer from '../../componentes/footer/Footer';
import Section from '../../componentes/ui/Section';
import MiDataTable from '../../componentes/ui/MiDataTable';
import PermissionRefused from '../../componentes/ui/PermissionRefused';
import LoadingPage from '../../componentes/ui/LoadingPage';
import MiDataTableResponse from './MiDataTableResponse';
import MiDataTableResponseProv from './MiDataTableResponseProv';
import MiDataTableLineas from '../request/MiDataTableLineas';
import Kpi from '../../componentes/ui/Kpi';
import Button from '../../componentes/ui/Button';
import ButtonOutline from '../../componentes/ui/ButtonOutline';
import MiSelect from '../../componentes/formulario/MiSelect';
import MiSelectMultiple from '../../componentes/formulario/MiSelectMultiple';
import TextArea from '../../componentes/formulario/TextArea';
import FormInput from '../../componentes/formulario/FormInput';
import { Spinner } from 'react-bootstrap';
import swal from 'sweetalert';
import { Modal } from 'react-bootstrap';
import { Fragment } from 'react';
import FormRow from '../../componentes/formulario/FormRow';
import { NavLink } from 'react-router-dom';
import { alertService } from '../../services/alertservice';
import { Alert } from '../../componentes/ui/Alert';
import useLogicForm from '../../hooks/useLogicForm';
import Cookies from 'universal-cookie';
import { getApiUrl, axiosPost, MiReplaceAll, getAhoraddmmyyyy, getPantDocFromNivel, setStockOptionsSelectUbi, getStockOptionsSelectUbi, getTitle, encryptData, getDecodedCookie } from '../../helpers/helperApp';


$.DataTable = DataTable;
const url = window.location;

function Response(props){

    const cookies = new Cookies();
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    // ***** Context *****
    const { validateSesion, socket, confApp, saveConfApp, getConfApp, apiKey, appCryptCom } = useContext(LoginContext);    

    // ***** State para la configuración de la pantalla *****
    const [ confPantalla, saveConfPantalla ] = useState(confApp)
    const [ loadedConf, saveLoadedConf ] = useState(false);
    const [ tieneNivel, saveTieneNivel ] = useState(true);    
    const [ responses, saveResponses ] = useState([]);
    const [ responsesProv, saveResponsesProv ] = useState([]);
    const [ infoDoc, saveInfoDoc ] = useState(null);
    const [ loadingTable, saveLoadingTable ] = useState(false);    
    const [ loadingTableProv, saveLoadingTableProv ] = useState(false);
    const [ loadingTable2, saveLoadingTable2 ] = useState(false);
    const [ showModalEditarLineas, saveShowModalEditarLineas ] = useState(false);
    const [ lineasModalEditar, saveLineasModalEditar ] = useState([]);
    const [ solicitando, saveSolicitando ] = useState(false); 
    const [ showModalAceptar, saveShowModalAceptar ] = useState(false);
    const [ rowDataAceptar, saveRowDataAceptar ] = useState ([]);
    const [ notasModalAceptar, saveNotasModalAceptar ] = useState("");
    const [ subjectModalAceptar, saveSubjectModalAceptar ] = useState("");
    const [ lineaAceptada, saveLineaAceptada ] = useState(false);  
    const [ docEnEdicionModal, saveDocEnEdicionModal ] = useState();

    // ***** Custom Hook - Lógica de los formularios *****
    // const {  loadingTable, saveLoadingTable, loadReg } = useLogicForm();

    useEffect( () => {        
        
        // ***** Validamos que el usuario esté logueado sino lo enviamos al login*****
        validateSesion(props)
            .then( (respuesta) => {
                if( confPantalla === undefined ){
                    return getConfApp();
                }else{ 
                    document.title = getTitle(confPantalla.config.trad, confPantalla.response.title);                    
                    if( respuesta == 1 ){
                        saveTieneNivel(true);
                        // Seleccionar los parámetros que nos llegan por la url                        
                        if( props.location.state ){
                            if( "iddoc" in props.location.state ){
                                loadInfoDoc(props.location.state.iddoc);                                
                                loadResponse(props.location.state.iddoc);
                                loadResponseProv(props.location.state.iddoc);                                
                            }                               
                        }                        
                    }
                    else if( respuesta == 0 ){
                        saveTieneNivel(false);
                    }                    
                    saveLoadedConf(true);        
                }
            })
            .then( (respuesta) => {
                if( respuesta !== undefined  ){
                    saveConfPantalla(respuesta.msg);
                    saveConfApp(respuesta.msg);             
                }
            })          

        // Liberamos todos los registros al salir de la pantalla
        return () =>{
            if( socket != null ){
                socket.emit("salirPantalla", { "idusu": getDecodedCookie('id'), "tabla": "undefined" })
            }
                document.querySelector("body").classList.remove("sidebar-open");

                // Token cancelación axios al desmontar componentes
                source.cancel();
        } 

    },[confPantalla])


    const loadInfoDoc = async(idDoc) => {
        const data = new FormData();      
        data.append("validacion", apiKey());
        data.append("iddoc", idDoc);
        const respuesta = await axiosPost(getApiUrl(window.location.origin)+confPantalla.response.controles.loadinfodoc, data, source.token);        
        if( typeof respuesta.data == "string"){
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true});         
        }else{
            saveInfoDoc(respuesta.data[0]);
        }
    }

    const loadResponse = async(idDoc) => {
        saveLoadingTable(true);
        const data = new FormData();      
        data.append("validacion", apiKey());
        data.append("iddoc", idDoc);
        const respuesta = await axiosPost(getApiUrl(window.location.origin)+confPantalla.response.controles.datatable.getdata, data, source.token);        
        if( typeof respuesta.data == "string"){
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true});         
        }else{
            saveResponses(respuesta.data);
        }
        saveLoadingTable(false);
    }

    const loadResponseProv = async(idDoc) => {
        saveLoadingTableProv(true);
        const data = new FormData();      
        data.append("validacion", apiKey());
        data.append("iddoc", idDoc);
        const respuesta = await axiosPost(getApiUrl(window.location.origin)+confPantalla.response.controles.datatableprov.getdata, data, source.token);        
        if( typeof respuesta.data == "string"){
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true});         
        }else{
            saveResponsesProv(respuesta.data);
        }
        saveLoadingTableProv(false);
    }

    const getColumnsDinamyc = () => {        
        let columns = [];                       
        columns.push({ title: confPantalla.response.controles.datatable.labelarticulo.title, data: "articulo"});
        columns.push({ title: confPantalla.response.controles.datatable.labelcantidad.title, data: "cantidad"});         
        columns.push({ title: confPantalla.response.controles.datatable.labelconfirmados.title, data: "confirmados"});         
        if(responses.length > 0){
            let keys = Object.keys(responses[0]);                           
            keys.forEach(key => {                              
                if(key != "articulo" && key != "cantidad" && key != "confirmados" && key != "id" && key != "iddoc" && key != "iduni" && !key.includes('_max') && key != 'totofe' && !key.includes('idlin') ){
                    if(key.includes('nom_')){
                        columns.push({ title: responses[0][key], data: key});                        
                    }else if(key.includes('coste_p')){                                                                         
                        columns.push({ title: confPantalla.response.controles.datatable.labelcantidadp.title, data: key});
                    }else if(key.includes('fecha_p')){
                        columns.push({ title: confPantalla.response.controles.datatable.labelfecha.title, data: key});                    
                    }else if(key.includes('cantidad_p')){
                        columns.push({ title: confPantalla.response.controles.datatable.labelcantidadped.title, data: key});
                    }else if(key.includes('cantidad_a')){
                        columns.push({ title: confPantalla.response.controles.datatable.labelcantidada.title, data: key});
                    }
                }
            });            
        }        
        return columns;
    }    
    
    const editarLineas = async (rowData) => {              
        saveDocEnEdicionModal(rowData)
        saveLoadingTable2(true);
        const data = new FormData();      
        data.append("validacion", apiKey());
        data.append("iddoc", rowData.iddoc);
        const respuesta = await axiosPost(getApiUrl(window.location.origin)+confPantalla.request.controles.modaleditarlineas.datatablelineas.getdata, data, source.token);
        if( typeof respuesta.data == "string"){
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true});         
        }else{            
            saveLineasModalEditar(respuesta.data);
            if(rowData.idest == 9){
                saveLineaAceptada(true);
            }else{
                saveLineaAceptada(false);
            }
            saveShowModalEditarLineas(true);
        }
        saveLoadingTable2(false);                
    }

    const accionEditarLineas = async () => {
            
        saveSolicitando(true);

        const data = new FormData();      
        data.append("validacion", apiKey());
        data.append("lineas", JSON.stringify(lineasModalEditar));            
        const respuesta = await axiosPost(getApiUrl(window.location.origin)+confPantalla.request.controles.modaleditarlineas.updatelineasmodaleditar, data, source.token);        
        if( typeof respuesta.data == "string"){
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true});         
        }else{
            alertService.success(`<i class="fal fa-check-circle mr-1"></i>${confPantalla.request.controles.modaleditarlineas.editadook.title}`, {autoClose: true});
            await loadInfoDoc(infoDoc.id);                                
            await loadResponse(infoDoc.id);
            await loadResponseProv(infoDoc.id);            
        }  
        saveSolicitando(false);
        saveShowModalEditarLineas(false);
    }

    const aceptar = (rowData) => {
        saveShowModalAceptar(true);
        saveNotasModalAceptar(rowData.defaultnotas)
        saveSubjectModalAceptar(rowData.defaultsubject);
        saveRowDataAceptar(rowData);
    }

    const accionAceptar = async () => {
            
        saveSolicitando(true);

        const data = new FormData();      
        data.append("validacion", apiKey());
        data.append("idlinea", rowDataAceptar.id);
        data.append("iddoc", rowDataAceptar.iddoc);
        data.append("notas", notasModalAceptar);
        data.append("subject", subjectModalAceptar);
        const respuesta = await axiosPost(getApiUrl(window.location.origin)+confPantalla.response.controles.modalaceptar.aceptar, data, source.token);        
        if( typeof respuesta.data == "string"){
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true});         
        }else{
            alertService.success(`<i class="fal fa-check-circle mr-1"></i>${confPantalla.response.controles.modalaceptar.aceptarok.title}`, {autoClose: true});
            await loadResponse(infoDoc.id);
            await loadResponseProv(infoDoc.id);  
        }
        saveSolicitando(false);
        saveShowModalAceptar(false);
    }

    const handleInput = (e, saveData) => {        
        const { name, value } = e.target;
        saveData(value)       
    }
    
    return(
        <div className="App wrapper">   
        {
            confPantalla !== undefined
            ?
                <Fragment>
                    <Alert fondo={true} />
                    <Menusup 
                        props = { props }
                    />
                    <Sidebar 
                        props = { props }
                    />
                </Fragment>
            :
            null
        } 
        <div className="content-wrapper">
            <div className="content-header">
            </div>
            <section className="content">                
                {
                    !tieneNivel 
                    ?
                        <PermissionRefused
                            traduction={confPantalla.config.trad.components.permissionrefused} 
                        />
                    :
                    <Fragment>
                    {
                        loadedConf === true && confPantalla !== undefined
                        ?
                            <Section
                                titulo={ 
                                    infoDoc == null
                                    ?
                                        confPantalla.response.section.titulo
                                    :
                                        getDecodedCookie('idioma').toLowerCase() == "es".toLowerCase() ?
                                            infoDoc.tipdocnom+" - "+infoDoc.nom1
                                        :
                                            getDecodedCookie('idioma').toLowerCase() == "en".toLowerCase() ?
                                                infoDoc.tipdocnom+" - "+infoDoc.nom1_en
                                            :
                                                infoDoc.tipdocnom+" - "+infoDoc.nom1+" - "+infoDoc.nom1_en
                                }  
                                icono={ confPantalla.response.section.icono } 
                                col={ confPantalla.response.section.col } 
                                idPrin={ infoDoc ? infoDoc.id : ''  } 
                                borderHeader={ infoDoc != null ? infoDoc.color : null }
                                idDocGoToRunCicCfg={ infoDoc ? infoDoc.id : null }
                                infoDocActual={infoDoc}                                         
                            >
                                {   loadingTable == true ?
                                        <div className='mt-4' style={{height:50, marginTop:5, marginBottom:10, textAlign: "center"}} >
                                            <Spinner animation="border" />
                                        </div>
                                    :
                                    <MiDataTableResponse 
                                        estadoForm= { "" }
                                        formulario={ {id:0} }
                                        id={"tablaResponse"}
                                        columnas={getColumnsDinamyc()}                                        
                                        data={responses}
                                        saveData={saveResponses}
                                        buttons={confPantalla.response.controles.datatable.buttons}
                                        ordering={confPantalla.response.controles.datatable.ordering}
                                        order={confPantalla.response.controles.datatable.order}
                                        searching={confPantalla.response.controles.datatable.searching}
                                        paging={confPantalla.response.controles.datatable.paging}
                                        select={confPantalla.response.controles.datatable.select}
                                        pagelength={confPantalla.response.controles.datatable.pagelength}                            
                                        columnactions={confPantalla.response.controles.datatable.title}
                                        linkColumns={confPantalla.response.controles.datatable.linkColumns}
                                        traduction={confPantalla.config.trad.components.datatable}
                                        infoDoc={infoDoc}
                                        loadResponse={loadResponse}                                                    
                                    />                                       
                                }
                                {   loadingTableProv == true ?
                                        <div className='mt-4' style={{height:50, marginTop:5, marginBottom:10, textAlign: "center"}} >
                                            <Spinner animation="border" />
                                        </div>
                                    :
                                    <MiDataTableResponseProv 
                                        estadoForm= { "" }
                                        formulario={ {id:0} }
                                        id={"tablaResponseProv"}
                                        columnas={confPantalla.response.controles.datatableprov.columns}
                                        data={responsesProv}
                                        buttons={confPantalla.response.controles.datatableprov.buttons}
                                        ordering={confPantalla.response.controles.datatableprov.ordering}
                                        order={confPantalla.response.controles.datatableprov.order}
                                        searching={confPantalla.response.controles.datatableprov.searching}
                                        paging={confPantalla.response.controles.datatableprov.paging}
                                        select={confPantalla.response.controles.datatableprov.select}
                                        pagelength={confPantalla.response.controles.datatableprov.pagelength}                            
                                        columnactions={confPantalla.response.controles.datatableprov.title}
                                        linkColumns={confPantalla.response.controles.datatableprov.linkColumns}
                                        traduction={confPantalla.config.trad.components.datatable}
                                        infoDoc={infoDoc}
                                        editarLineas={editarLineas}
                                        confPantalla={confPantalla}
                                        loadResponse={loadResponse}
                                        loadResponseProv={loadResponseProv}
                                        saveLoadingTableProv={saveLoadingTableProv}
                                        aceptar={aceptar}                                                                                          
                                    />                                       
                                }
                            </Section>
                        :
                            <LoadingPage />
                        }
                    </Fragment>
                }
                {
                showModalEditarLineas
                ?
                    <Modal
                        show={showModalEditarLineas}
                        onHide={ () => saveShowModalEditarLineas(false)}                            
                        aria-labelledby="example-custom-modal-styling-title"
                        centered={true}                    
                        dialogClassName="modal-90w "
                        backdrop="static" 
                        backdropClassName='requestmodalrespbackdrop'                                       
                    >
                        <Modal.Header closeButton>                            
                            {
                                lineaAceptada == true
                                ?
                                    <div class="alert alert-success text-center w-100 font-weight-bold" role="alert">
                                        <i className="fal fa-box-check fa-2x mr-1"></i>
                                        {confPantalla.request.controles.modaleditarlineas.txtlineaaceptada.title}
                                    </div>
                                :
                                    <h4>{confPantalla.request.controles.modaleditarlineas.header.title}</h4>
                            }                                              
                        </Modal.Header>
                        <Modal.Body>                                                                                
                            <MiDataTableLineas 
                                estadoForm= { "" }
                                formulario={ {id:0} }
                                id={"responsemodaleditar"}
                                columnas={confPantalla.request.controles.modaleditarlineas.datatablelineas.columns}
                                data={lineasModalEditar}
                                saveData={saveLineasModalEditar}
                                buttons={confPantalla.request.controles.modaleditarlineas.datatablelineas.buttons}
                                ordering={confPantalla.request.controles.modaleditarlineas.datatablelineas.ordering}
                                order={confPantalla.request.controles.modaleditarlineas.datatablelineas.order}
                                searching={confPantalla.request.controles.modaleditarlineas.datatablelineas.searching}
                                paging={confPantalla.request.controles.modaleditarlineas.datatablelineas.paging}
                                select={confPantalla.request.controles.modaleditarlineas.datatablelineas.select}
                                pagelength={confPantalla.request.controles.modaleditarlineas.datatablelineas.pagelength}                                    
                                columnactions={confPantalla.request.controles.modaleditarlineas.datatablelineas.columnactions.title}
                                linkColumns={confPantalla.request.controles.modaleditarlineas.datatablelineas.linkColumns}
                                traduction={confPantalla.config.trad.components.datatable}
                                modallineaseditar={true}
                                importExportFile={true}
                                fnReloadTable={{fn: editarLineas, key: "iddoc"}}
                                idRegImportExport={docEnEdicionModal.iddoc}
                                saveLoadingTable={saveSolicitando}                                
                            />                            
                            {  solicitando ? 
                                    <div className='mt-4' style={{height:50, marginTop:5, marginBottom:10, textAlign: "center"}} >
                                        <Spinner animation="border" />
                                    </div>
                                :
                                null
                            }                                                
                        </Modal.Body>
                        <Modal.Footer>
                            <div className='text-right'>
                                <button 
                                        className="btn btn-success mt-1 mr-1"
                                        onClick={ () => accionEditarLineas() }
                                        disabled={solicitando ? true : false}                                        
                                >
                                    {confPantalla.request.controles.modaleditarlineas.btnaceptar.title}
                                </button>
                                <button 
                                    className="btn btn-danger mt-1"
                                    onClick={ () => saveShowModalEditarLineas(false) }
                                >
                                    {confPantalla.request.controles.modaleditarlineas.btncancelar.title}
                                </button>                             
                            </div>
                        </Modal.Footer>                            
                    </Modal>
                :
                    null
                }
                {
                showModalAceptar
                ?
                    <Modal
                        show={showModalAceptar}
                        onHide={ () => saveShowModalAceptar(false)}                            
                        aria-labelledby="example-custom-modal-styling-title"
                        centered={true}                    
                        dialogClassName="modal-90w "
                        backdrop="static" 
                        backdropClassName='requestmodalrespbackdrop'                                       
                    >
                        <Modal.Header closeButton>
                            <h4>{confPantalla.response.controles.modalaceptar.header.title}</h4>
                        </Modal.Header>                                              
                        <Modal.Body>
                            <FormRow>                            
                                <FormInput                                                        
                                    estadoForm= { "" }
                                    value=      { subjectModalAceptar }
                                    loading=    { solicitando ? true : false }
                                    id=         { confPantalla.request.controles.modalsolicitar.subject.id }   
                                    type=       { confPantalla.request.controles.modalsolicitar.subject.type }  
                                    name=       { confPantalla.request.controles.modalsolicitar.subject.name }   
                                    label=      { confPantalla.request.controles.modalsolicitar.subject.label }                                                       
                                    placeholder={ confPantalla.request.controles.modalsolicitar.subject.placeholder }    
                                    col=        { confPantalla.request.controles.modalsolicitar.subject.col } 
                                    required=   { confPantalla.request.controles.modalsolicitar.subject.required }
                                    readonly=   { confPantalla.request.controles.modalsolicitar.subject.readonly }                                                
                                    disabled=   { confPantalla.request.controles.modalsolicitar.subject.disabled }
                                    change=     { e => handleInput(e, saveSubjectModalAceptar) }
                                    onBlur=     {null} 
                                />
                            </FormRow>
                            <FormRow>
                                <TextArea                                                        
                                    estadoForm= { "" }
                                    // value=      { MiReplaceAll(notasModalAceptar, '<br>', '') }
                                    value=      { notasModalAceptar }
                                    loading=    { solicitando ? true : false }
                                    id=         { confPantalla.response.controles.modalaceptar.notas.id }   
                                    name=       { confPantalla.response.controles.modalaceptar.notas.name }
                                    rows=       { confPantalla.response.controles.modalaceptar.notas.rows }      
                                    label=      { confPantalla.response.controles.modalaceptar.notas.label }                                                       
                                    placeholder={ confPantalla.response.controles.modalaceptar.notas.placeholder }    
                                    col=        { confPantalla.response.controles.modalaceptar.notas.col } 
                                    required=   { confPantalla.response.controles.modalaceptar.notas.required }
                                    readonly=   { confPantalla.response.controles.modalaceptar.notas.readonly }                                                
                                    disabled=   { confPantalla.response.controles.modalaceptar.notas.disabled }
                                    change=     { e => handleInput(e, saveNotasModalAceptar) }
                                    onBlur=     {null} 
                                />                                                                               
                            </FormRow>
                            <p className="font-italic text-center">{confPantalla.response.controles.modalaceptar.required.title}</p>                
                            {  solicitando ? 
                                    <div className='mt-4' style={{height:50, marginTop:5, marginBottom:10, textAlign: "center"}} >
                                        <Spinner animation="border" />
                                    </div>
                                :
                                null
                            }                                                
                        </Modal.Body>
                        <Modal.Footer>
                            <div className='text-right'>
                                <button 
                                        className="btn btn-success mt-1 mr-1"
                                        onClick={ () => accionAceptar() }
                                        disabled={solicitando || notasModalAceptar == "" ||  subjectModalAceptar == "" ? true : false}                                        
                                >
                                    {confPantalla.response.controles.modalaceptar.btnaceptar.title}
                                </button>
                                <button 
                                    className="btn btn-danger mt-1"
                                    onClick={ () => saveShowModalAceptar(false) }
                                >
                                    {confPantalla.response.controles.modalaceptar.btncancelar.title}
                                </button>                             
                            </div>
                        </Modal.Footer>                            
                    </Modal>
                :
                    null
                }                                    
            </section>
        </div>
        <Footer />        
        </div>

    );

}
export default Response